/**
 * Quantity Selector — handles +/- buttons on product pages and cart drawer.
 *
 * Guard: prevents double-registration when the script is loaded
 * from multiple sections (product page + cart-drawer).
 */
(function () {
  if (window.__qtyInit) return;   /* already registered — skip */
  window.__qtyInit = true;

  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus  = e.target.closest('[data-qty-plus]');
    var btn   = minus || plus;
    if (!btn) return;

    var wrapper = btn.closest('[data-qty-wrapper]');
    if (!wrapper) return;

    var input = wrapper.querySelector('[data-qty-input]');
    if (!input) return;

    var current = parseInt(input.value, 10) || 1;

    if (minus && current > 1) {
      input.value = current - 1;
    } else if (plus) {
      input.value = current + 1;
    }

    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();